import React from 'react'

const MsTeams = () => {
  return (
    <div></div>
  )
}

export default MsTeams